// extracted by mini-css-extract-plugin
export default {"Contact":"Contact_Contact__Es1ST","first":"Contact_first__wi8Qx","form":"Contact_form__Hp1Bg"};